import type { Theme, SxProps } from '@mui/material/styles';
import { forwardRef } from 'react';
import Iconify from './iconify';

// ----------------------------------------------------------------------

export type FlagIconProps = {
    code?: string;
    sx?: SxProps<Theme>;
    isCircle?: boolean;
};

export const FlagIcon = forwardRef<HTMLSpanElement, FlagIconProps>(
    ({ code, sx, isCircle = true }, ref) => {
        if (!code) {
            return null;
        }

        return (
            <Iconify
                key={code}
                icon={isCircle ? `circle-flags:${code}` : `flag:${code}-4x3`}
                ref={ref}
                sx={{ width: 16, height: 16, lineHeight: 1, display: 'inline-flex', verticalAlign: 'middle', ...sx }}
            />
        );
    }
);
